var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderer.inFocus)?_c(_vm.renderer.is,_vm._b({tag:"component"},'component',_vm.renderer,false)):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }